<div class="mentions-editor" *ngIf="removable?.length > 0 || nonRemovable?.length > 0">
  <div class="label-container">
    <span class="target-notifications">{{ "users_will_notified" | localize }}</span>
    <button *ngIf="removable?.length > 0" [attr.aria-label]="removeAllMentionsAriaLabel" (click)="removeAll.emit()" ui-button uiType="link" uiSize="small">({{ "remove_all" | localize }})</button>
  </div>
  <div class="mention-list-item removable" *ngFor="let mentionId of removable | slice : 0 : limit">
    <!-- TODO: https://quantive-inc.atlassian.net/browse/GVS-37028 -->
    <!-- gh-track="Button Clicked" -->
    <!-- gh-track-meta="{ button_name: 'remove_person_from_comment_notification' }" -->
    <ui-assignee-avatar [uiShowTooltip]="true" [fromAssigneeId]="mentionId" (click)="removeOne.emit(mentionId)" uiSize="sm"></ui-assignee-avatar>
  </div>
  <ui-assignee-avatar
    class="mention-list-item"
    *ngFor="let mentionId of nonRemovable"
    [uiShowTooltip]="true"
    [uiTooltipTitle]="'to_remove_comment' | localize"
    [fromAssigneeId]="mentionId"
    uiSize="sm"></ui-assignee-avatar>
  <span class="sp-ml-6 show-more-button" *ngIf="removable.length > limit" [class.cursor-pointer]="limit < 20" (click)="limit = 20"> + {{ removable.length - limit }} {{ "more" | localize }}</span>
</div>
